import { Reducer } from 'redux';

import { WalletHistoryState, WalletHistoryTypes } from './types';

const INITIAL_STATE: WalletHistoryState = {
  walletHistoryList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<WalletHistoryState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES GET WALLET HISTORY
    case WalletHistoryTypes.GET_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        walletHistoryList: INITIAL_STATE.walletHistoryList,
      };

    case WalletHistoryTypes.GET_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        walletHistoryList: action.payload.walletHistoryList,
      };

    case WalletHistoryTypes.GET_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        walletHistoryList: INITIAL_STATE.walletHistoryList,
      };

    default:
      return state;
  }
};

export default reducer;
